<template>
  <div class="c-app flex-row align-items-center">
    <CContainer style="display: flex; justify-content: center" class="p-0">
      <div class="container-box center">
        <div class="text-left">
          <div class="card-custom-web">
            <br />
            <div>
              <CDataTable
              :hover="hover"
              :striped="striped"
              :bordered="bordered"
              :small="small"
              :fixed="fixed"
              :items="wallets"
              :fields="wallet"
              :items-per-page="small ? 5 : 50"
              :dark="dark"
              pagination
              class="mr-2 ml-2"
            >
              <!-- <template #No="{ index }">
                        <td>
                          <div class="text-uppercase font-weight-bold">
                            {{ index + 1 }}
                          </div>
                        </td>
                      </template> -->
              <template #Details="{ item }" hidden>
                <td>
                  <div>
                    <div class="custom-month ml-3">
                      <label>{{
                        item.transactionDate | moment("MMMM YYYY")
                      }}</label>
                    </div>
                    <CCol sm="12">
                      <CRow>
                        <CCol sm="8">
                          <span class="mt-3 float-left">
                            {{ item.description }}
                            <br /><span class="custom-span-title">{{
                              item.transactionDate
                                | moment("dddd, Do MMMM, h:mm:ss a")
                            }}</span>
                          </span>
                        </CCol>
                        <CCol sm="4">
                          <div v-if="item.debit == 0">
                            <span
                              v-if="item.credit"
                              class="mt-3 float-right"
                              style="color: green"
                              >RM {{ item.credit }}</span
                            >
                          </div>
                          <div v-if="item.credit == 0">
                            <span
                              v-if="item.debit"
                              class="mt-3 float-right"
                              style="color: red"
                              >RM {{ item.debit }}</span
                            >
                          </div>
                        </CCol>
                      </CRow>
                    </CCol>
                  </div>
                </td>
              </template>
            </CDataTable>
            </div>
            
            <!-- <div
              class="list-grade"
              v-for="wal in wallets"
              :key="wal.Id"
              :index="wal.Id"
            >
              <br />
              <hr />
              <div class="custom-month ml-3">
                <label>{{ wal.transactionDate | moment("MMMM YYYY") }}</label>
              </div>
              <CCol sm="12">
                <CRow>
                  <CCol sm="8">
                    <span class="mt-3 float-left">
                      {{ wal.description }}
                      <br /><span class="custom-span-title">{{
                        wal.transactionDate | moment("dddd, Do MMMM, h:mm:ss a")
                      }}</span>
                    </span>
                  </CCol>
                  <CCol sm="4">
                    <div v-if="wal.debit == 0">
                      <span
                        v-if="wal.credit"
                        class="mt-3 float-right"
                        style="color: green"
                        >RM {{ wal.credit }}</span
                      >
                    </div>
                    <div v-if="wal.credit == 0">
                      <span
                        v-if="wal.debit"
                        class="mt-3 float-right"
                        style="color: red"
                        >RM {{ wal.debit }}</span
                      >
                    </div>
                  </CCol>
                </CRow>
              </CCol>
              <br />
            </div> -->
            <br />
          </div>
        </div>
      </div>
    </CContainer>
    <div class="header-top">Transaction History</div>
    <div class="header-left">
      <img src="../../assets/img/icon/VectorLeft.svg" @click="GoBack()" />
    </div>
    <div style="clear: both"></div>
  </div>
</template>

<script>
import Vue from "vue";
Vue.use(require("vue-moment"));
import moment from "moment";

export default {
  data() {
    return {
      DeleteNotification: false,
      user: {},
      wallets: [],
      wallet: [{ key: "Details" }],
    };
  },
  async mounted() {
    let isAuth = await this.UserAuth();

    if (isAuth) {
      this.Busy = false;
      this.GetInfoUser();
    } else {
      this.GoToLogin();
    }
  },
  methods: {
    OpenDelete() {
      this.DeleteNotification = true;
    },
    GoBack() {
      this.$router.back();
    },
    GetInfoUser() {
      return this.$API
        .get(this.$LoginUserDetailWebs, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200) {
            this.user = response.data;
            this.GetListWallet(this.user.id);
          }
        });
    },
    GetListWallet() {
      this.$API
        .get(this.$GetWalletListAll + "?id=" + this.user.id, {
          withCredentials: true,
        })
        .then((response) => {
          if (response.status == 200 && response.data != null) {
            this.wallets = response.data;
          }
        });
    },
  },
};
</script>

<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Poppins&display=swap");

input {
  border-bottom: 2px solid #dbdbdb;
  background: none;
  border-top: none;
  border-left: none;
  border-right: none;
  width: 90%;
}

input ::placeholder {
  color: #e0e0e0;
}

::placeholder {
  /* Chrome, Firefox, Opera, Safari 10.1+ */
  color: #e0e0e0;
}
.c-app {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
}
.custom-bg-color {
  background: linear-gradient(286.01deg, #5bc4ff 7.93%, #0085ff 96.74%);
  /* Clickable/Light */

  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.05);
  border-radius: 8px;
  margin: 0px 20px;
  display: flex;
  justify-content: center;
}
body {
  font-family: "Montserrat", sans-serif;
}

.class-teach-name {
  padding: 4px 1px;
  top: 45px;
  /* height: 40px; */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 20px;

  /* Pure/White */

  color: #ffffff;

  /* Inside auto layout */

  /* flex: none;
  order: 0;
  flex-grow: 0; */
}
.custom-btn-add {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 150%;

  color: #007cef;
}
.custom-promo-text {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  align-items: center;

  color: #000a2c;
}
.custom-promo-title {
  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: 29px;

  color: #000a2c;
}
.custom-title-sum {
  width: 59px;
  height: 17px;

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  /* Biru 2 Pickiddo */

  color: #007cef;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
.custom-span-title {
  width: 207px;
  height: 17px;

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 17px;
  /* identical to box height */

  /* #000A2C */

  color: #000a2c;

  /* Inside auto layout */

  flex: none;
  order: 1;
  flex-grow: 0;
}
.custom-month {
  width: 335px;
  height: 15px;

  /* Smallest/Semibold */

  font-family: "Montserrat";
  font-style: normal;
  font-weight: 600;
  font-size: 10px;
  line-height: 150%;
  /* identical to box height, or 15px */

  color: #787878;

  /* Inside auto layout */

  flex: none;
  order: 0;
  flex-grow: 0;
}
</style>